import state from "./state.js"
import mutations from "./mutations.js"

export default {
	state,
	mutations
}
